import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';

export class WebpackTranslateLoader implements TranslateLoader {

  public constructor(
    private http: HttpClient,
    private version: string,
  ) {}
  public getTranslation(lang: string): Observable<Record<string, string>> {
    return this.http.get<Record<string, string>>(
      `../../../assets/i18n/${lang}.json`,
      { params: { v: this.version } }
    );
  }
}